export default __webpack_public_path__ + "static/media/logo_title.6ef31332.svg";